import { forwardRef } from "react";

import { BaseSocialPostCard } from "../base-social-post-card";

export const SocialPostCardSkeleton = forwardRef((_, ref) => {
  return <BaseSocialPostCard ref={ref} data={null} />;
});
